var CK=JSON.parse(document.getElementById("ck-i18n").textContent);
(function(){
"use strict";
var $=function(id){return document.getElementById(id)};
var qs=new URLSearchParams(location.search);
/* 25.9.2026: snippets/as-key-guard.liquid nimmt o, k und t vor allen Skripten aus der Adresse und legt sie in sessionStorage; hier kommen sie aus window.__asEsimKey(). Ohne Waechter weiter aus der Adresse. */
var AK=(typeof window.__asEsimKey==="function"&&window.__asEsimKey())||{};
var TOK=(qs.get("t")||qs.get("k")||AK.t||AK.k||"").trim(); if(!/^[A-Za-z0-9]{32}$/.test(TOK)) TOK="";
var O=(qs.get("o")||AK.o||"").trim();
var WORKER="https://aerosims-support-agent.aerosims-esim.workers.dev";
var ROOT=CK._root||"/"; if(ROOT.slice(-1)!=="/") ROOT+="/";
var PLAN=null, DAILY=false, APN="", FULL=null, TRAIL=[];

function fmtDate(ts){ try{ return new Intl.DateTimeFormat(document.documentElement.lang||undefined,{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"}).format(new Date(ts)); }catch(e){ return new Date(ts).toLocaleString(); } }
function gb(b){ return (b/1073741824).toFixed(1); }

/* ---------- Plan-Kopf + Auto-Diagnose über den öffentlichen Share-Token ---------- */
if(TOK){
  fetch("https://api.esimaccess.com/api/v1/h5/share/order/queryUsage?token="+encodeURIComponent(TOK))
   .then(function(r){return r.json()}).then(function(j){
    var o=j&&j.obj; if(!o||!o.dataPlanName) return;
    PLAN=o; DAILY=/\/\s*Day/i.test(o.dataPlanName||""); APN=o.apn||"";
    var exp=Date.parse(String(o.expiredTime||"").replace(/([+-]\d{2})(\d{2})$/,"$1:$2"));
    var h="<b>"+o.dataPlanName+"</b>";
    if(!isNaN(exp)) h+=" &middot; "+CK.expiresLbl+" "+fmtDate(exp);
    if(!DAILY && +o.totalVolume>0) h+="<br>"+gb(+o.dataUsage||0)+" / "+gb(+o.totalVolume)+" GB "+CK.usedLbl;
    $("ck-plan").innerHTML=h; $("ck-plan").style.display="block";
    var CTRY=(o.dataPlanName||"").replace(/\s*\d.*$/,"").trim();
    if(!isNaN(exp)&&exp<Date.now()){ TRAIL.push("auto:expired"); auto(CK.autoExpiredT, CK.autoExpired.replace("{t}",fmtDate(exp)), CTRY?(CK.autoBuy.replace(/\s*\u2192\s*$/,"")+" \u00B7 "+CTRY+" \u2192"):null, CTRY?(ROOT+"search?q="+encodeURIComponent(CTRY+" eSIM")):null); }
    else if(!DAILY && +o.totalVolume>0 && (+o.dataUsage||0)>=+o.totalVolume){ TRAIL.push("auto:used-up"); if(O&&TOK){ auto(CK.autoUsedT, CK.autoUsed, CK.myesim, ROOT+"pages/my-esim#o="+encodeURIComponent(O)+"&k="+encodeURIComponent(TOK)); } else { auto(CK.autoUsedT, CK.autoUsed, CTRY?(CK.autoBuy.replace(/\s*\u2192\s*$/,"")+" \u00B7 "+CTRY+" \u2192"):null, CTRY?(ROOT+"search?q="+encodeURIComponent(CTRY+" eSIM")):null); } }
  }).catch(function(){});
}
/* Server-Wahrheit: voller Status, wenn o+k vorhanden (Kunde kam von My eSIM) */
if(O&&TOK){
  fetch(WORKER+"/myesim?o="+encodeURIComponent(O)+"&k="+encodeURIComponent(TOK)).then(function(r){return r.json()}).then(function(d){
    if(!d||!d.ok) return; FULL=d;
    var st=String(d.status||"").toUpperCase(), inst=!!d.installTime;
    var dexp=Date.parse(String(d.expiredTime||"").replace(/([+-]\d{2})(\d{2})$/,"$1:$2"));
    var expOk=!(!isNaN(dexp)&&dexp<Date.now());
    if(!inst&&expOk){ TRAIL.push("srv:never-installed"); auto(CK.autoNotInstT, CK.autoNotInst, CK.autoInstallCta, ROOT+"pages/my-esim"); var ckab=$("ck-auto-buy"); if(ckab&&/\/pages\/my-esim$/.test(ckab.getAttribute("href")||"")) ckab.setAttribute("data-as-key","t"); }
    else if(expOk && st.indexOf("IN_USE")<0 && st.indexOf("USED")<0){ TRAIL.push("srv:installed-never-connected"); auto(CK.autoNoNetT, CK.autoNoNet, CK.lcGoFix, null, "fx_ns"); }
    else if(expOk && st.indexOf("IN_USE")>=0 && (+d.dataUsed||0)>104857600){ TRAIL.push("srv:data-flowing"); chip(CK.flowChip.replace("{g}", gb(+d.dataUsed))); }
  }).catch(function(){});
}
function auto(t,p,cta,href,node){ if($("ck-auto").style.display==="block") return; $("ck-auto-t").textContent=t; $("ck-auto-p").textContent=p; var b=$("ck-auto-buy"); if(cta){ b.textContent=cta; } if(href){ b.setAttribute("href",href); } if(node){ b.setAttribute("href","#"); b.addEventListener("click",function(ev){ ev.preventDefault(); go(node); document.getElementById("ck-wiz").scrollIntoView({behavior:"smooth"}); }); } $("ck-auto").style.display="block"; }
function chip(txt){ var d=document.createElement("div"); d.className="ck-res"; d.style.display="block"; d.style.marginTop="14px"; d.textContent=txt; document.querySelector(".ck-hero").appendChild(d); }

/* ---------- Wizard ---------- */
var TREE={
 q1:{q:CK.q1,opts:[[CK.q1a,"qi"],[CK.q1b,"qn"],[CK.q1c,"fx_nd"],[CK.q1d,"sp"],[CK.q1e,"fx_already"]]},
 qi:{q:CK.qi,opts:[[CK.qia,"fx_already"],[CK.qib,"fx_manual"],[CK.qic,"fx_compat"],[CK.qid,"fx_retry"]]},
 qn:{q:CK.qn,opts:[[CK.qna,"fx_home"],[CK.qnb,"fx_ns"]]},
 fx_already:{t:CK.fixAlreadyT,steps:[CK.fixAlready]},
 fx_manual:{t:CK.fixManualT,steps:[CK.fixManual]},
 fx_compat:{t:CK.fixCompatT,steps:[CK.fixCompat],guide:ROOT+"blogs/travel-guide/esim-compatible-phones-2026"},
 fx_retry:{t:CK.fixRetryT,steps:[CK.fixRetry]},
 fx_home:{t:CK.fixHomeT,steps:[CK.fixHome]},
 fx_ns:{t:CK.fixNsT,steps:[CK.fixNs1,CK.fixNs2,CK.fixNs3,CK.fixNs4]},
 fx_nd:{t:CK.fixNdT,steps:[CK.fixNd1,CK.fixNd2,CK.fixNd3]},
 solved:{t:CK.solvedT,steps:[CK.solved],end:1},
 contact:{t:CK.contactT,steps:[CK.contact],contact:1,end:1}
};
var STACK=[];
function osName(){ var u=navigator.userAgent||""; if(/iPhone|iPad|iPod/i.test(u)) return "iPhone / iOS"; if(/Android/i.test(u)){ var m=u.match(/Android [0-9.]+; ([^);]+)/); return "Android"+(m?(" · "+m[1].trim()):""); } return "Desktop/andere"; }
var NODE_LBL={qi:"can't install",qn:"No Service",fx_nd:"signal but no internet",sp:"slow internet",fx_already:"code already used / eSIM gone",fx_manual:"manual install",fx_compat:"compatibility check",fx_retry:"install retry",fx_home:"still at home (normal)",fx_ns:"4-step reconnect",solved:"SOLVED",contact:"support options opened"};
function trailLines(){
  var out=[];
  TRAIL.forEach(function(t){
    if(t==="srv:never-installed") out.push("\u26A0\uFE0F System: QR NEVER scanned, nothing installed");
    else if(t==="srv:installed-never-connected") out.push("\u26A0\uFE0F System: installed, but never connected to a network");
    else if(t==="srv:data-flowing") out.push("\u2705 System: data has been flowing");
    else if(t==="auto:expired") out.push("\u23F0 Auto-diagnosis: eSIM EXPIRED");
    else if(t==="auto:used-up") out.push("\uD83D\uDCC9 Auto-diagnosis: data used up");
    else if(t.indexOf("live:base:")===0) out.push("\uD83C\uDF10 Live check baseline: "+t.slice(10));
    else if(t==="live:no-mobile") out.push("\uD83D\uDD34 Live check: NO mobile data path");
    else if(t==="live:same-net") out.push("\uD83D\uDFE1 Live check: same network as baseline (Wi-Fi still on?)");
    else if(t.indexOf("live:mobile-ok:")===0) out.push("\uD83D\uDFE2 Live check: online via mobile data, "+t.slice(15));
    else if(t.indexOf("speed:")===0) out.push("\u26A1 Speed test: "+t.slice(6));
    else if(t.indexOf(">")>0){ var a=t.split(">"); var from=NODE_LBL[a[0]]||a[0], to=NODE_LBL[a[1]]||a[1];
      if(a[0]==="q1") out.push("\uD83E\udded Problem chosen: "+to);
      else if(a[1]==="contact") out.push("\u2717 Fix \u201C"+from+"\u201D did NOT help");
      else if(a[1]==="solved") out.push("\u2705 Fix \u201C"+from+"\u201D SOLVED it");
      else out.push("\u2022 "+from+" \u2192 "+to);
    }
  });
  return out;
}
function waMsg(){
  var L=["\uD83E\uDDF0 eSIM-CHECK REPORT"];
  if(FULL&&FULL.shopOrder) L.push("\uD83E\uDDFE Shopify order: #"+FULL.shopOrder);
  if(FULL&&FULL.email) L.push("\u2709\uFE0F Email: "+FULL.email);
  if(O) L.push("\uD83D\uDCE6 Supplier ref: "+O);
  if(PLAN&&PLAN.dataPlanName) L.push("\uD83D\uDCF1 Plan: "+PLAN.dataPlanName);
  if(PLAN&&PLAN.iccid) L.push("\uD83D\uDD22 ICCID: "+PLAN.iccid);
  if(FULL) L.push((FULL.installTime?"\uD83D\uDFE2 Installed":"\uD83D\uDD34 NEVER installed (QR not scanned)")+" \u00B7 status "+(FULL.status||"?"));
  if(PLAN&&PLAN.expiredTime){ var e=Date.parse(String(PLAN.expiredTime).replace(/([+-]\d{2})(\d{2})$/,"$1:$2")); L.push("\u23F3 Valid until "+String(PLAN.expiredTime).slice(0,16).replace("T"," ")+" UTC"+((!isNaN(e)&&e<Date.now())?" (EXPIRED)":"")); }
  if(PLAN&&+PLAN.totalVolume>0) L.push("\uD83D\uDCCA Usage: "+gb(+PLAN.dataUsage||0)+" / "+gb(+PLAN.totalVolume)+" GB");
  L.push("\uD83D\uDCDF "+osName()+" \u00B7 page "+(document.documentElement.lang||"en"));
  var tl=trailLines();
  if(tl.length){ L.push("---"); tl.forEach(function(x){L.push(x);}); }
  return L.join("\n");
}
function esc(s){var d=document.createElement("div");d.textContent=s;return d.innerHTML;}
function show(id){
  var n=TREE[id], w=$("ck-wiz"), h="";
  if(id==="sp"){ go("q1"); runSpeed(); document.getElementById("ck-speed").scrollIntoView({behavior:"smooth"}); return; }
  if(n.q){
    h="<h2>"+esc(n.q)+"</h2>";
    n.opts.forEach(function(o,i){ h+="<button class='ck-opt' data-n='"+o[1]+"'>"+esc(o[0])+"</button>"; });
  } else {
    h="<h2>"+esc(n.t)+"</h2>";
    if(n.steps.length===1){ h+="<p style='margin:0'>"+esc(n.steps[0]).replace("{apn}", APN?(" (“"+esc(APN)+"”)"):"")+"</p>"; }
    else n.steps.forEach(function(s,i){ h+="<div class='ck-step'><div class='n'>"+(i+1)+"</div><p>"+esc(s).replace("{apn}", APN?(" (“"+esc(APN)+"”)"):"")+"</p></div>"; });
    if(n.guide) h+="<div class='ck-row'><a class='ck-btn' href='"+n.guide+"'>→ Guide</a></div>";
    if(n.contact){ h+="<p class='ck-sub' style='margin:0 0 4px'>"+esc(CK.contactProof)+"</p><div class='ck-row'><button class='ck-btn pri' id='ck-sky' style='flex:2 1 60%'>\uD83D\uDCAC "+esc(CK.askSky)+"</button><button class='ck-btn' id='ck-copy'>"+esc(CK.copyBtn)+"</button>"+(O&&TOK?"<a class='ck-btn' data-as-key='t' href='"+ROOT+"pages/my-esim'>"+esc(CK.myesim)+"</a>":"")+"</div>"; }
    else if(!n.end){ h+="<p class='ck-sub' style='margin-top:16px'><b>"+esc(CK.helped)+"</b></p><div class='ck-row'><button class='ck-btn pri' data-n='solved'>"+esc(CK.yes)+"</button><button class='ck-btn' data-n='contact'>"+esc(CK.no)+"</button></div>"; }
    else if(n.end&&!n.contact&&O&&TOK){ h+="<div class='ck-row'><a class='ck-btn' data-as-key='t' href='"+ROOT+"pages/my-esim'>"+esc(CK.myesim)+"</a></div>"; }
  }
  if(STACK.length) h+="<p style='margin:14px 0 0'><button class='ck-link' data-back='1'>← "+esc(STACK.length>1?CK.back:CK.startOver)+"</button></p>";
  w.innerHTML=h;
  w.querySelectorAll("[data-n]").forEach(function(b){ b.addEventListener("click",function(){ STACK.push(id); TRAIL.push(id+">"+b.getAttribute("data-n")); show(b.getAttribute("data-n")); }); });
  var bk=w.querySelector("[data-back]"); if(bk) bk.addEventListener("click",function(){ show(STACK.pop()||"q1"); });
  var sk=w.querySelector("#ck-sky"); if(sk) sk.addEventListener("click",function(){
    if(typeof window.SkyOpen==="function"){ window.SkyOpen(waMsg()); }
    else { location.href="mailto:support@aerosims.com?subject="+encodeURIComponent("eSIM Check")+"&body="+encodeURIComponent(waMsg()); }
  });
  var cp=w.querySelector("#ck-copy"); if(cp) cp.addEventListener("click",function(){
    var txt=waMsg();
    function done(){ cp.textContent=CK.copied; }
    if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(txt).then(done,function(){ fallback(); }); } else fallback();
    function fallback(){ var ta=document.createElement("textarea"); ta.value=txt; document.body.appendChild(ta); ta.select(); try{document.execCommand("copy");}catch(e){} document.body.removeChild(ta); done(); }
  });
  osHi(w);
}
function go(id){ STACK=[]; show(id); }
go("q1");

/* ---------- Netz-Info (eigener Worker) ---------- */
fetch(WORKER+"/netinfo").then(function(r){return r.json()}).then(function(n){
  if(!n||!n.ok) return;
  var parts=[]; if(n.org) parts.push("<b>"+esc(n.org)+"</b>");
  var loc=[n.city,n.country].filter(Boolean).join(", "); if(loc) parts.push(esc(loc));
  if(n.ip) parts.push("<span style='color:#7c88a8'>"+esc(n.ip)+"</span>");
  if(parts.length){ $("ck-net").innerHTML="<span style='font-size:12px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#7c88a8'>"+esc(CK.spNet)+"</span><br>"+parts.join(" · "); $("ck-net").style.display="block"; }
}).catch(function(){});

/* ---------- Speedtest (Cloudflare-Endpunkte, CORS-offen) ---------- */
/* ---------- Live-Check: welches Netz trägt die Daten? ---------- */
function lcShow(html){ var r=$("ck-lc-res"); r.innerHTML=html; r.style.display="block"; }
function lcNet(cb){ fetch(WORKER+"/netinfo?_="+Date.now(),{cache:"no-store"}).then(function(r){return r.json()}).then(function(n){cb(null,n)}).catch(function(e){cb(e)}); }
function lcLabel(n){ return "<b>"+esc(n.org||"?")+"</b>"+(n.city||n.country?(" · "+esc([n.city,n.country].filter(Boolean).join(", "))):"")+(n.ip?(" · <span style='color:#7c88a8'>"+esc(n.ip)+"</span>"):""); }
$("ck-lc-a").addEventListener("click",function(){
  lcNet(function(err,n){ if(err||!n||!n.ok){ lcShow("✕"); return; }
    try{ sessionStorage.setItem("ck_lc_base", JSON.stringify({ip:n.ip,org:n.org})); }catch(e){}
    TRAIL.push("live:base:"+(n.org||"?"));
    lcShow(esc(CK.lcNow)+" "+lcLabel(n)+"<br><b>"+esc(CK.lcBase)+"</b>");
  });
});
$("ck-lc-b").addEventListener("click",function(){
  lcNet(function(err,n){
    if(err||!n||!n.ok){ TRAIL.push("live:no-mobile"); lcShow("<b style='color:#c02626'>"+esc(CK.lcFail)+"</b><br><button class='ck-link' id='ck-lc-fix'>"+esc(CK.lcGoFix)+"</button>"); var f=document.getElementById("ck-lc-fix"); if(f) f.addEventListener("click",function(){ go("fx_ns"); document.getElementById("ck-wiz").scrollIntoView({behavior:"smooth"}); }); return; }
    var base=null; try{ base=JSON.parse(sessionStorage.getItem("ck_lc_base")||"null"); }catch(e){}
    if(base && base.ip===n.ip){ TRAIL.push("live:same-net"); lcShow(esc(CK.lcNow)+" "+lcLabel(n)+"<br><b style='color:#b45309'>"+esc(CK.lcSame)+"</b>"); }
    else { TRAIL.push("live:mobile-ok:"+(n.org||"?")); lcShow(esc(CK.lcNow)+" "+lcLabel(n)+"<br><b style='color:#0f8a4d'>"+esc(CK.lcOk)+"</b>"); }
  });
});
function osHi(w){
  var isI=/iPhone|iPad|iPod/i.test(navigator.userAgent), isA=/Android/i.test(navigator.userAgent);
  if(!isI&&!isA) return;
  w.querySelectorAll(".ck-step p, h2 ~ p").forEach(function(p){
    if(p.getAttribute("data-oshi")) return;
    var t=p.innerHTML, iI=t.indexOf("iPhone:"), iA=t.indexOf("Android:");
    if(iI<0||iA<0) return;
    var first=Math.min(iI,iA), second=Math.max(iI,iA);
    var head=t.slice(0,first), segA=t.slice(first,second), segB=t.slice(second);
    var mineFirst=(isI&&iI<iA)||(isA&&iA<iI);
    var on='<span style="background:#eaf6ff;border-radius:6px;padding:1px 4px;">', off='<span style="opacity:.45;">';
    p.innerHTML=head+(mineFirst?on:off)+segA+"</span>"+(mineFirst?off:on)+segB+"</span>";
    p.setAttribute("data-oshi","1");
  });
}
var CF="https://speed.cloudflare.com";
function timed(p){ var t0=performance.now(); return p.then(function(){ return performance.now()-t0; }); }
function ping(){
  var seq=Promise.resolve(), times=[];
  for(var i=0;i<6;i++) (function(){ seq=seq.then(function(){ return timed(fetch(CF+"/__down?bytes=1",{cache:"no-store"})).then(function(ms){ times.push(ms); }); }); })();
  return seq.then(function(){ times.shift(); times.sort(function(a,b){return a-b}); return Math.round(times[Math.floor(times.length/2)]); });
}
function download(){
  var sizes=[1048576,5242880,15728640], best=0, chain=Promise.resolve(), t0=performance.now();
  sizes.forEach(function(sz){
    chain=chain.then(function(){
      if(performance.now()-t0>8000) return;
      var s0=performance.now();
      return fetch(CF+"/__down?bytes="+sz,{cache:"no-store"}).then(function(r){return r.arrayBuffer()}).then(function(b){
        var secs=(performance.now()-s0)/1000, mbps=(b.byteLength*8)/(secs*1e6);
        if(mbps>best) best=mbps;
      });
    });
  });
  return chain.then(function(){ return best; });
}
function upload(){
  var body=new Uint8Array(2097152), s0=performance.now();
  return fetch(CF+"/__up",{method:"POST",body:body,cache:"no-store"}).then(function(){
    var secs=(performance.now()-s0)/1000; return (body.length*8)/(secs*1e6);
  });
}
var APPS=[["TikTok","https://www.tiktok.com/favicon.ico"],["Instagram","https://www.instagram.com/favicon.ico"],["WhatsApp","https://www.whatsapp.com/favicon.ico"],["YouTube","https://www.youtube.com/favicon.ico"],["Google","https://www.google.com/favicon.ico"],["ChatGPT","https://chatgpt.com/favicon.ico"],["Facebook","https://www.facebook.com/favicon.ico"],["X","https://abs.twimg.com/favicons/twitter.3.ico"]];
function appRow(name){ var d=document.createElement("div"); d.className="ck-app"; d.innerHTML="<span>"+name+"</span><span class='st'>…</span>"; $("ck-apps").appendChild(d); return d.lastChild; }
function checkApps(){
  $("ck-apps").innerHTML="";
  APPS.forEach(function(a){
    var st=appRow(a[0]), t0=performance.now(), done=false;
    var to=setTimeout(function(){ if(!done){done=true; st.textContent="✕"; st.className="st r";} },6000);
    fetch(a[1]+"?ck="+Date.now(),{mode:"no-cors",cache:"no-store"}).then(function(){
      if(done)return; done=true; clearTimeout(to);
      var ms=Math.round(performance.now()-t0);
      st.textContent=ms+" ms"; st.className="st "+(ms<500?"g":(ms<1500?"a":"r"));
    }).catch(function(){ if(done)return; done=true; clearTimeout(to); st.textContent="✕"; st.className="st r"; });
  });
}
var RUNNING=false;
function runSpeed(){
  if(RUNNING) return; RUNNING=true;
  var go=$("ck-go"); go.disabled=true; go.textContent=CK.spTesting;
  $("ck-res").style.display="none"; $("ck-fup").style.display="none";
  $("ck-ping").textContent="…"; $("ck-down").textContent="…"; $("ck-up").textContent="…";
  checkApps();
  var down=0;
  ping().then(function(p){ $("ck-ping").textContent=p; return download(); })
  .then(function(d){ down=d; $("ck-down").textContent=d.toFixed(1); return upload().catch(function(){return null}); })
  .then(function(u){ $("ck-up").textContent=u==null?"—":u.toFixed(1); TRAIL.push("speed:"+$("ck-ping").textContent+" ms \u00B7 "+down.toFixed(1)+"\u2193 / "+(u==null?"?":u.toFixed(1))+"\u2191 Mbps");
    var r=$("ck-res"); r.textContent = down>=5?CK.spResGood:(down>=1?CK.spResOk:CK.spResBad); r.style.display="block";
    if(DAILY&&down<1.5) $("ck-fup").style.display="block";
  })
  .catch(function(){ $("ck-res").textContent="✕"; $("ck-res").style.display="block"; })
  .then(function(){ RUNNING=false; go.disabled=false; go.textContent=CK.spAgain; });
}
$("ck-go").addEventListener("click",runSpeed);
if((qs.get("mode")||"")==="speed"){ document.getElementById("ck-speed").scrollIntoView(); }
})();
